/** Routes du module — propriétaire : Agent A3 — Livraison et transport (admin). */
import type { RouteObject } from 'react-router';
import { Route as IconeRoute } from 'lucide-react';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { PageLivraison, PageLivraisons } from './Livraisons';

export const routesAdminLivraison: RouteObject[] = [
  { path: 'livraisons', element: <RequirePermission permission="livraison.gerer"><PageLivraisons /></RequirePermission> },
  { path: 'livraisons/:commandeId', element: <RequirePermission permission="livraison.gerer"><PageLivraison /></RequirePermission> },
];

export const navAdminLivraison: EntreeNav[] = [
  { libelle: 'Livraisons', vers: '/admin/livraisons', permission: 'livraison.gerer', icone: IconeRoute, groupe: 'Logistique' },
];
